import React from 'react';
import { Droplet } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-110">
          <div className="flex items-center gap-2" data-id="element-111">
            <div className="bg-blue-600 p-1.5 rounded-md" data-id="element-112">
              <Droplet className="w-5 h-5 text-white fill-white" data-id="element-113" />
            </div>
            <div className="flex flex-col" data-id="element-114">
              <span className="font-bold text-lg leading-none text-white tracking-tight" data-id="element-115">
                Aqua Pool
              </span>
              <span className="text-[10px] font-semibold text-blue-400 tracking-widest uppercase" data-id="element-116">
                Service
              </span>
            </div>
          </div>

          <div className="flex gap-6 text-sm" data-id="element-117">
            <button onClick={() => document.getElementById('services')?.scrollIntoView({
            behavior: 'smooth'
          })} className="hover:text-white transition-colors" data-id="element-118">
              Services
            </button>
            <button onClick={() => document.getElementById('why-us')?.scrollIntoView({
            behavior: 'smooth'
          })} className="hover:text-white transition-colors" data-id="element-119">
              Why Us
            </button>
            <button onClick={() => document.getElementById('gallery')?.scrollIntoView({
            behavior: 'smooth'
          })} className="hover:text-white transition-colors" data-id="element-120">
              Gallery
            </button>
            <button onClick={() => document.getElementById('about')?.scrollIntoView({
            behavior: 'smooth'
          })} className="hover:text-white transition-colors" data-id="element-121">
              About
            </button>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-122">
          <p data-id="element-123">
            &copy; {new Date().getFullYear()} Aqua Pool Service. All rights
            reserved.
          </p>
          <p data-id="element-124">Serving Rocklin, Roseville & Sacramento</p>
        </div>
      </div>
    </footer>;
}